export const DROPDOWN_TEXT = 'Please select';
export const EMAIL_PLACEHOLDER_TEXT = 'E.g. john@domain.com';
export const PHONE_NUMBER_TEXT = 'E.g. 0871234567';